import React from "react";
import { GridCellKind } from "@glideapps/glide-data-grid";
import { makeStyles } from "tss-react/mui";
import { CanvasRenderingContext2DExtended } from "../CanvasRenderingContext2DExtended.js";
import { rowHeight } from "../types.js";
import { GlideCell } from "./GlideCell.js";
class GlideTextCell extends GlideCell {
  _cellKind = "text";
  constructor(valueGetter, emptySymbol) {
    super(valueGetter, emptySymbol);
  }
  getRenderer(muiTheme) {
    return {
      kind: GridCellKind.Custom,
      isMatch: (cell) => cell.data.kind === this._cellKind,
      needsHover: false,
      draw: (args, cell) => {
        const value = cell.data.value;
        const { ctx, theme, rect } = args;
        const fontSizeProperty = muiTheme.typography.body1.fontSize;
        const fontSize = typeof fontSizeProperty === "string" ? Number.parseInt(fontSizeProperty) : fontSizeProperty;
        ctx.font = `normal ${cell.data.isSummary ? "bold" : "normal"} ${fontSize}px ${theme.fontFamily}`;
        ctx.fillStyle = theme.textDark;
        const drawArea = this.getDrawArea(rect, theme);
        const textCtx = new CanvasRenderingContext2DExtended(args.ctx);
        textCtx.fillTextWithEllipsis(value, drawArea.width, drawArea.x, drawArea.y + rowHeight / 2);
      }
    };
  }
  getCustomContent(value, isSummary) {
    return {
      kind: GridCellKind.Custom,
      copyData: value,
      data: {
        kind: this._cellKind,
        value,
        isSummary,
        tooltip: value ? TextCellTooltipContent : null
      },
      allowOverlay: false
    };
  }
  isCellEmpty(value) {
    return !value;
  }
  formatValue(value) {
    if (value && typeof value !== "string") {
      throw new Error(`Invalid value: ${value}`);
    }
    return value?.toString();
  }
}
const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: theme.custom.tooltipMaxWidth
  }
}));
function TextCellTooltipContent({ value }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement("div", { className: classes.container }, value);
}
export {
  GlideTextCell
};
//# sourceMappingURL=GlideTextCell.js.map
